// removed by extract-text-webpack-plugin
module.exports = {"root":"AutosuggestModel-module-root-33U9O","cross-btn":"AutosuggestModel-module-cross-btn-2b0hx","crossBtn":"AutosuggestModel-module-cross-btn-2b0hx","is-car-plate-search":"AutosuggestModel-module-is-car-plate-search-3EW6F","isCarPlateSearch":"AutosuggestModel-module-is-car-plate-search-3EW6F","hint":"AutosuggestModel-module-hint-whq1s","home":"AutosuggestModel-module-home-3Ah6O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestModel/AutosuggestModel.module.scss
// module id = 1004
// module chunks = 0